import React, { useEffect, useState } from "react";
import {
  CancelButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAllBrands,
  updateBrand,
} from "../../../redux/features/assetManagementSlice";

const EditBrand = ({ rowData, dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.assetmanagement);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      brand_id: rowData.brand_id,
      brand_name: rowData.brand_name,
      brand_description: rowData.brand_description,
      // brand_status: rowData.brand_status,
    },
    onSubmit: (values) => {
      dispatch(updateBrand({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getAllBrands(dispatchParams));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  const brandStatusDemo = [
    { id: 0, name: "Active" },
    { id: 1, name: "Inactive" },
  ];
  return (
    <GlobalDialog
      title={"Update Brand"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="brand_name"
                    value={formik.values.brand_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Brand Name"
                  />
                  <TextField
                    name="brand_description"
                    value={formik.values.brand_description}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Description"
                  />
                  {/* <GlobalSelectField
                    options={{
                      formik,
                      name: "brand_status",
                      label: "Status",
                      data: brandStatusDemo,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  /> */}
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default EditBrand;
